export const slideOptions = (swiperRef, allSlidesVisible, isPDP) => {
  return {
    spaceBetween: 22,
    freeMode: false,
    slidesOffsetAfter: 12,
    slidesOffsetBefore: 12,
    observer: true,
    observeParents: true,
    watchOverflow: true,
    slidesPerView: 'auto',
    breakpoints: {
      320: {
        slidesOffsetAfter: allSlidesVisible ? 0 : 12,
        slidesOffsetBefore: allSlidesVisible ? 0 : 12,
        scrollbar: {
          dragSize: 62,
        },
      },
      767: {
        slidesOffsetAfter: allSlidesVisible ? 0 : isPDP ? 14 : 24,
        slidesOffsetBefore: allSlidesVisible ? 0 : isPDP ? 14 : 60,
      },
      1024: {
        slidesOffsetAfter: allSlidesVisible ? 0 : isPDP ? 66 : 24,
        slidesOffsetBefore: allSlidesVisible ? 0 : isPDP ? 66 : 80,
        scrollbar: {
          dragSize: isPDP ? 200 : 400,
        },
      },
      1500: {
        slidesOffsetAfter: isPDP ? 66 : 24,
        slidesOffsetBefore: isPDP ? 66 : 80,
        scrollbar: {
          dragSize: isPDP ? 200 : 650,
        },
      },
      2000: {
        slidesOffsetAfter: isPDP ? 66 : 0,
        slidesOffsetBefore: isPDP ? 66 : 0,
        centeredSlidesBounds: true,
        centerInsufficientSlides: true,
      },
    },
    onSwiper: (swiper) => {
      swiperRef.current = swiper;
    },
  };
};
